module.exports = "/lucky-balls/img/combos-sr/84-.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos-sr/84-.png
// module id = 996
// module chunks = 0